import { useEffect, useRef } from 'react'
import { useTranslation } from '@/i18n'

export interface PouleTabItem {
  id: string
  label: string
  isPlaceholder?: boolean
}

export function PouleTabs({
  items,
  activeTab,
  onChange,
}: {
  items: PouleTabItem[]
  activeTab: string
  onChange: (nextTab: string) => void
}) {
  const { t } = useTranslation()
  const activeTabRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    activeTabRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    })
  }, [activeTab])

  return (
    <div
      className="overflow-hidden rounded-[0.95rem] border border-white/[0.06] bg-[#151a1c] p-1"
      role="tablist"
      aria-label={t('Poule navigatie')}
    >
      <div className="no-scrollbar flex min-w-0 snap-x snap-mandatory gap-1 overflow-x-auto overscroll-x-contain touch-pan-x">
        {items.map((item) => {
          const isActive = item.id === activeTab

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onChange(item.id)}
              ref={isActive ? activeTabRef : undefined}
              role="tab"
              aria-selected={isActive}
              aria-current={isActive ? 'page' : undefined}
              className={[
                'inline-flex min-h-11 shrink-0 snap-start items-center whitespace-nowrap rounded-[0.75rem] px-4 py-2 text-sm font-semibold transition focus-visible:ring-2 focus-visible:ring-accent-400 focus-visible:ring-offset-2 focus-visible:ring-offset-[#151a1c]',
                isActive
                  ? 'bg-white/[0.09] text-white shadow-sm ring-1 ring-white/[0.1]'
                  : 'text-surface-300 hover:bg-[#1d2528] hover:text-surface-100 focus-visible:bg-[#1d2528] focus-visible:text-white',
              ].join(' ')}
            >
              {item.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
